import _ from 'lodash';
import { useTranslation } from 'react-i18next';
import * as api from '../../api';
import { constructAddress } from '../../utils/practice';
import styles from './index.module.css';

interface Props {
  practice: Omit<api.Practice.SafePractice, 'zip' | 'name'> & {
    name?: string;
  };
  virtualVisit?: boolean;
}

export const AppointmentLocationView: React.FC<Props> = ({
  practice,
  virtualVisit,
}) => {
  const { t } = useTranslation();
  const { name } = practice;
  const location = constructAddress(_.omit(practice, 'zip'));

  return (
    <>
      {virtualVisit && (
        <div className={styles.PracticeName}>{t('Virtual Visit')}</div>
      )}
      {name && <div className={styles.PracticeName}>{name}</div>}
      {!virtualVisit && <div className={styles.Location}>{location}</div>}
    </>
  );
};
